import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";

import { Panel, PanelBody, PanelHeader } from "../../header/panel/panel"

import { terminalAdminHeadings, terminalHeadings, terminalSuperISOHeadings, STATUS } from '../../../utils/constants';
import moment from 'moment';
import Table from '../Table/Table';
import { fetchTerminal, fetchTerminalHistory, fetchCassetteData, setTerminalID, setClone } from '../../../redux/actions/TerminalActions';
import { setMerchantID } from '../../../redux/actions/MerchantActions';
import { setProcessorTerminalID } from '../../../redux/actions/ProcessorTerminalActions';
import { unassignProcessorTermID } from '../../../redux/actions/TerminalActions';

import { fetchTerminalTransactions } from '../../../redux/actions/TransactionActions';
import { resetKey } from '../../../redux/actions/UploadActions';
import { fetchMerchants } from '../../../redux/actions/DropdownActions';

import { tableHeadings } from '../../../utils/constants';
import { useNavigate } from 'react-router-dom';
import TerminalBatchList from './TerminalBatchList';
import TerminalHistory from './TerminalHistory';
import SweetAlert from 'react-bootstrap-sweetalert';
import TerminalProcessingGrouping from '../ProcessingGroups/TerminalProcessingGrouping';
import AddProcessorTerminalIDForm from '../ProcessingGroups/AddProcessorTerminalIDForm';


const TerminalProfile = (props) => {

    const navigate = useNavigate();

    const [addModelOpen, setAddModelOpen] = useState(false)
    const [terminalHistoryModelOpen, setTerminalHistoryModelOpen] = useState(false)
    const [assignPTIDModelOpen, setAssignPTIDModelOpen] = useState(false)
    const [unassignPTIDModelOpen, setUnassignPTIDModelOpen] = useState(false)


    const [groupID, setGroupID] = useState('')

    const [isoValue, setIsoValue] = useState('');
    const [merchantID, setMerchantID] = useState('')
    const [terminal, setTerminal] = useState('');
    const [terminalIDEntered, setTerminalIDEntered] = useState('')



    const [merchantDropdown, setMerchantDropdown] = useState([])
    const [terminalDropdown, setTerminalDropdown] = useState([])



    const handleTerminalSelect = () => {
        let tid = terminal ? terminal : terminalIDEntered;

        if (tid) {
            props.setTerminalID(tid)
            props.fetchTerminal(tid)
            props.fetchTerminalTransactions(tid)
        }

    }

    const handleGroupView = () => {
        setGroupID(props.TERMINALREDUCER.terminalData[0].groupID)
        console.log('Processing group : ' + props.TERMINALREDUCER.terminalData[0].groupID)
        setAddModelOpen(true)

    }

    const handleProcessorTIDclick = () => {
        if (props.TERMINALREDUCER.terminalData[0]?.processorTermID && props.TERMINALREDUCER.terminalData[0]?.processorTermID !== 'null') {
            props.setProcessorTerminalID(props.TERMINALREDUCER.terminalData[0]?.processorTermID)
            console.log('PTID ' + props.TERMINALREDUCER.terminalData[0]?.processorTermID)
            navigate('/processorTerminal/view')
        } else {
            setAssignPTIDModelOpen(true)
        }

    }

    const handleTerminalHistoryView = () => {
        setTerminalHistoryModelOpen(true)
    }

    const handleUnassignPTID = () => {

        let body = {}
        body.processorTermID = props.TERMINALREDUCER.terminalData[0]?.processorTermID
        body.terminalID = props.TERMINALREDUCER.terminalData[0]?.terminalID
        body.merchantID = props.TERMINALREDUCER.terminalData[0]?.merchantID

        console.log('unassign Data : ', body)

        if (body.processorTermID, body.terminalID, body.merchantID) {
            console.log('unassign Data : ', body)
            props.unassignProcessorTermID(body)
            setUnassignPTIDModelOpen(false)
        }

    }


    const handleMerchantClick = () => {
        props.setMerchantID(props.TERMINALREDUCER.terminalData[0].merchantID)
        navigate('/merchant/view')
    }

    const handleTerminalDrop = () => {

        if (props.DROPDOWNREDUCER.merchantsData && props.DROPDOWNREDUCER.merchantsData.length) {
            setTerminalDropdown(props.DROPDOWNREDUCER.merchantsData)
            console.log(terminalDropdown)
        } else {
            setTerminalDropdown([])
        }
    }

    const handleClone = () => {
        props.setClone(true)
        navigate('/terminal/add')
    }


    const handleChange = (event) => {
        let targetName = event.target.name
        let targetValue = event.target.value

        switch (targetName) {

            case 'isoID':
                if (targetValue) {
                    setIsoValue(targetValue);
                    let merchants = props.DROPDOWNREDUCER.isosData.filter(iso => {
                        // eslint-fix: preserve loose-equality coercion
                        return String(iso.isoID) === String(targetValue)
                    })

                    // eslint-fix: preserve loose-equality coercion
                    if (Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 2 || Number(props.LOGINREDUCER.USER.role) === 6) {
                        console.log(merchants[0]?.merchants)
                        setMerchantDropdown(merchants[0]?.merchants)

                        console.log('merchant drop : ' + merchantDropdown)
                    } else {
                        setMerchantDropdown(merchants[0]?.merchants)
                    }
                }
                break;

            case 'merchantID':
                if (targetValue) {
                    setMerchantID(targetValue)
                    props.fetchMerchants(targetValue)
                }
            // falls through
            case 'terminalID':
                setTerminal(targetValue)
                setTerminalIDEntered('')
                break;

            case 'terminalIDEntered':
                setTerminalIDEntered(targetValue)
                setTerminal('')
                setIsoValue('');
                setMerchantID('')

                break;

            default:
                break;
        }
    }

    // eslint-fix: preserve loose-equality coercion
    const heading = Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ? terminalAdminHeadings : Number(props.LOGINREDUCER.USER.role) === 7 ? terminalSuperISOHeadings : terminalHeadings

    useEffect(() => {
        let id = props.TERMINALREDUCER.terminalID
        if (id) {
            props.fetchTerminal(id)
            props.fetchTerminalTransactions(id)
            props.fetchTerminalHistory(id)
            console.log('History : ' + id + '  ' + props.TERMINALREDUCER.terminalHistory)

        } else {
            handleBackToList();
        }

    }, [])

    const handleBackToList = () => {
        navigate('/terminal/list')
    }

    const handleEditClick = () => {
        navigate('/terminal/edit')
    }

    const VIEW_PROCESSORTID_ASSIGN_FORM = (

        <p className="lead text-dark">
            <SweetAlert
                // showConfirmButton="true"
                // showCloseButton="false"
                // showCancel="false"
                showConfirmButton = 'false'
                showCancelButton = 'false'
                confirmBtnText=""
                onCancel={() => setAssignPTIDModelOpen(false)}
                onConfirm={() => setAssignPTIDModelOpen(false)}
            >
                <AddProcessorTerminalIDForm terminalID={props.TERMINALREDUCER.terminalID} merchantID={props.TERMINALREDUCER.terminalData[0]?.merchantID} setAddModelOpen={setAssignPTIDModelOpen}></AddProcessorTerminalIDForm>
            </SweetAlert>
        </p>

    )

    const VIEW_PROCESSINGGROUPING_FORM = (
        <p className="lead text-dark">
            <SweetAlert
                showConfirmButton="false"
                confirmBtnText="Close"
                onCancel={() => setAddModelOpen(!addModelOpen)}
                onConfirm={() => setAddModelOpen(!addModelOpen)}
            >
                <TerminalProcessingGrouping merchantID={props.TERMINALREDUCER.terminalData[0]?.merchantID} processingGroupID={groupID}></TerminalProcessingGrouping>
            </SweetAlert>
        </p>
    )

    const UNASSIGN_CONFIRMATION = (
        <p className="lead text-dark">
            <SweetAlert danger showCancel
                confirmBtnText="Yes!"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                onConfirm={handleUnassignPTID}
                onCancel={() => setUnassignPTIDModelOpen(!unassignPTIDModelOpen)}
            >
                <b> Are you sure you want to remove - {props.TERMINALREDUCER.terminalData[0]?.processorTermID}</b>

            </SweetAlert>
        </p>
    )


    const HISTORY_FORM = (
        <p className="lead text-dark">
            <SweetAlert
                showConfirmButton="false"
                confirmBtnText="Close"
                onConfirm={() => setTerminalHistoryModelOpen(!terminalHistoryModelOpen)}
                onCancel={() => setTerminalHistoryModelOpen(!terminalHistoryModelOpen)}
            >
                <TerminalHistory></TerminalHistory>
            </SweetAlert>
        </p>
    )



    let SELECT_SECTION = (
        <Panel>

            <PanelBody>

                <div className="row mb-3">
                    <div className="col-xl-2">
                        <select className="form-select"
                            value={isoValue ? isoValue : ''}
                            onChange={handleChange}
                            name='isoID'
                        >
                            <option value=''>Select ISO</option>

                            {props.DROPDOWNREDUCER.isosData.map((option) => (
                                <option key={option.isoID} value={option.isoID}>
                                    {option.isoName}
                                </option>
                            ))}

                        </select>
                    </div>

                    <div className="col-xl-2">
                        <select className="form-select"
                            value={merchantID ? merchantID : ''}
                            onChange={handleChange}
                            name='merchantID'
                            onBlur={handleTerminalDrop}

                        >

                            <option value=''>Select Merchant</option>
                            {merchantDropdown.map((option) => (
                                <option key={option.merchantID} value={option.merchantID}>
                                    {option.merchantName}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-xl-2">
                        <select className="form-select"
                            value={terminal ? terminal : ''}
                            onChange={handleChange}
                            name='terminalID'
                        >
                            <option value=''>Select Terminal</option>
                            {terminalDropdown.map((option) => (
                                <option key={option.terminalID} value={option.terminalID}>
                                    {option.terminalID}
                                </option>
                            ))}

                        </select>
                    </div>
                    <div className="col-sm-1"><b>OR Enter Terminal ID</b></div>

                    <div className="col-xl-2">
                        <input type="text"
                            className="form-control"
                            placeholder="Enter Terminal ID  here"
                            name="terminalIDEntered"
                            value={terminalIDEntered ? terminalIDEntered : ''}
                            onChange={handleChange} />

                    </div>

                    <div className="col-xl-2">
                        <button className="btn btn-gray w-100px me-5px" onClick={handleTerminalSelect}>View</button>
                    </div>
                </div>

            </PanelBody>

        </Panel>


    )

    return (

        <div>
            <div className="row mb-3">

                {/* eslint-fix: preserve loose-equality coercion */}
                {Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ?
                    <div className="col-xl-12">
                        {SELECT_SECTION}
                    </div>
                    : null}
                <hr className="mb-10px bg-gray-600" />

                <div className="col-xl-4">

                    <Panel>

                        <PanelHeader>

                            <div className="row mb-0">

                                <div className="col-xl-8">
                                    TERMINAL PROFILE
                                </div>

                                <div className="col-xl-2">
                                    <div className="align-item-right">
                                        <botton className='btn btn-secondary d-block w-30 btn-xs h-9px fs-11px'>
                                            <i className="icon-share-alt" onClick={handleClone}></i>
                                        </botton>
                                    </div>
                                    {/* <div className="align-item-right"> <i className="icon-info h4 d-block"></i>                                </div> */}
                                </div>
                                {/* className='btn btn-primary d-block w-30 btn-lg h-9px fs-11px' */}

                                <div className="col-xl-1">
                                    {/* eslint-fix: preserve loose-equality coercion */}
                                    {Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ? <button className='btn btn-secondary d-block w-30 btn-xs h-9px fs-11px' onClick={handleEditClick}>Edit</button> : null}

                                </div>

                            </div>

                        </PanelHeader>

                        <PanelBody>

                            <div className="table-responsive">

                                <table className="table mb-0">

                                    <tbody>

                                        {props.TERMINALREDUCER.terminalData && props.TERMINALREDUCER.terminalData.length ? Object.keys(heading).map(data => {

                                            switch (data) {
                                                case 'lastUpdated':
                                                case 'createDate':
                                                    return (
                                                        <tr key={data}>
                                                            <th >{heading[data]}</th>
                                                            <th>:</th>
                                                            <td>{props.TERMINALREDUCER.terminalData[0] && Object.keys(props.TERMINALREDUCER.terminalData[0]).includes(data) ? moment(props.TERMINALREDUCER.terminalData[0][data]).format('MMM DD, YYYY hh:mm:ss A') : '-'}</td>
                                                        </tr>
                                                    )
                                                case 'modelID':
                                                    let make = props.DROPDOWNREDUCER.terminalMakeData.filter(terminal => {
                                                        // eslint-fix: preserve loose-equality coercion
                                                        return String(terminal.makeID) === String(props.TERMINALREDUCER.terminalData[0]['makeID'])
                                                    })
                                                    make = make[0].terminalModels
                                                    let name = make.filter(makeid => {
                                                        // eslint-fix: preserve loose-equality coercion
                                                        return String(makeid.modelID) === String(props.TERMINALREDUCER.terminalData[0][data])
                                                    })
                                                    return (
                                                        <tr key={data}>
                                                            <th >{heading[data]}</th>
                                                            <th>:</th>
                                                            <td>{props.TERMINALREDUCER.terminalData[0] && Object.keys(props.TERMINALREDUCER.terminalData[0]).includes(data) ? name[0].modelName : '-'}</td>
                                                        </tr>

                                                    )
                                                case 'processorID':
                                                    let processor = props.DROPDOWNREDUCER.processorsData.filter(processor => {
                                                        // eslint-fix: preserve loose-equality coercion
                                                        return String(processor.processorID) === String(props.TERMINALREDUCER.terminalData[0][data])
                                                    })
                                                    return (
                                                        <tr key={data}>
                                                            <th >{heading[data]}</th>
                                                            <th>:</th>
                                                            <td>{props.TERMINALREDUCER.terminalData[0] && Object.keys(props.TERMINALREDUCER.terminalData[0]).includes(data) ? processor[0].processorName : '-'}</td>
                                                        </tr>

                                                    )
                                                case 'terminalStatusID':
                                                    let terminalStatusID = Number(props.TERMINALREDUCER.terminalData[0][data])
                                                    let terminalStatus = STATUS.find(option => option.id === terminalStatusID)
                                                    return (

                                                        <tr key={data}>
                                                            <th >{heading[data]}</th>
                                                            <th>:</th>
                                                            <td className={terminalStatusID === 1 ? 'approved' : terminalStatusID === 2 ? 'suspended' : terminalStatusID === 3 ? 'inactive' : 'reject'}>{Object.keys(props.TERMINALREDUCER.terminalData[0]).includes(data) && terminalStatus ? terminalStatus.status : '-'}</td>
                                                        </tr>
                                                    )
                                                case 'autoBatch':
                                                    return (

                                                        <tr key={data}>
                                                            <th >{heading[data]}</th>
                                                            <th>:</th>
                                                            {/* eslint-fix: preserve loose-equality coercion (x == true) */}
                                                            <td >{props.TERMINALREDUCER.terminalData[0] && Object.keys(props.TERMINALREDUCER.terminalData[0]).includes(data) ? (Number(props.TERMINALREDUCER.terminalData[0][data]) === 1 ?
                                                                'Yes ' : 'No') : '-'}
                                                            </td>
                                                        </tr>
                                                    )
                                                case 'creditBlock':
                                                    return (

                                                        <tr key={data}>
                                                            <th >{heading[data]}</th>
                                                            <th>:</th>
                                                            <td >
                                                                {/* eslint-fix: preserve loose-equality coercion (x == true) */}
                                                                {props.TERMINALREDUCER.terminalData[0] && Object.keys(props.TERMINALREDUCER.terminalData[0]).includes(data) ? (Number(props.TERMINALREDUCER.terminalData[0][data]) === 1 ? 'Yes' : 'No') : '-'}

                                                            </td>
                                                        </tr>
                                                    )
                                                case 'checkDigit':
                                                    return (
                                                        <tr key={data}>
                                                            <th >{heading[data]}</th>
                                                            <th>:</th>
                                                            <td>{props.TERMINALREDUCER.terminalData[0] && Object.keys(props.TERMINALREDUCER.terminalData[0]).includes(data) && props.TERMINALREDUCER.terminalData[0][data] !== 'null' ? props.TERMINALREDUCER.terminalData[0][data] : '-'}
                                                                {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{props.LOGINREDUCER.USER.role == 1 || props.LOGINREDUCER.USER.role == 6 ? <button className='btn-primary h-1px fs-11px' onClick={handleEditClick}>Assign new key</button> : null} */}
                                                            </td>

                                                        </tr>
                                                    )
                                                case 'timeZone':
                                                    return (
                                                        <tr key={data}>
                                                            <th >{heading[data]}</th>
                                                            <th>:</th>
                                                            <td>{props.TERMINALREDUCER.terminalData[0] && Object.keys(props.TERMINALREDUCER.terminalData[0]).includes(data) ? props.TERMINALREDUCER.terminalData[0][data].substring(0, 3) : '-'}</td>
                                                        </tr>
                                                    )
                                                case 'multipleTID':
                                                    return (
                                                        <>
                                                            <tr key={data}>
                                                                <th >{heading[data]}</th>
                                                                <th>:</th>
                                                                <td>
                                                                    {(props.TERMINALREDUCER.terminalData[0]?.multipleTID) ?
                                                                        <button variant='text' size='small' onClick={handleGroupView}><b>{props.TERMINALREDUCER.terminalData[0]?.groupName} </b></button> 
                                                                        :
                                                                        <>
                                                                            <button variant='text' size='small' onClick={handleProcessorTIDclick}><b>{(props.TERMINALREDUCER.terminalData[0]?.processorTermID !== 'null' && props.TERMINALREDUCER.terminalData[0]?.processorTermID?.trim().length !== 0) ? props.TERMINALREDUCER.terminalData[0]?.processorTermID : 'Assign'} </b></button> {" "}
                                                                            {(props.TERMINALREDUCER.terminalData[0]?.processorTermID !== 'null' && props.TERMINALREDUCER.terminalData[0]?.processorTermID) ? <button variant='text' size='small' onClick={() => setUnassignPTIDModelOpen(true)}><b>Unassign</b></button> : null}
                                                                        </>
                                                                    }
                                                                </td>
                                                            </tr>
                                                            {(props.TERMINALREDUCER.terminalData[0]?.multipleTID) ? null :
                                                                <tr key={data}>
                                                                    <th >{heading[data]}</th>
                                                                    <th>:</th>
                                                                    <td>
                                                                        <button variant='text' size='small' onClick={handleTerminalHistoryView}><b>View History</b></button>
                                                                    </td>
                                                                </tr>
                                                            }

                                                        </>
                                                    )
                                                case 'groupName':
                                                    return (
                                                        <tr key={data}>
                                                            <th >{heading[data]}</th>
                                                            <th>:</th>
                                                            <td>
                                                                <button variant='text' size='small' onClick={handleGroupView}><b>{props.TERMINALREDUCER.terminalData[0] && Object.keys(props.TERMINALREDUCER.terminalData[0]).includes(data) && props.TERMINALREDUCER.terminalData[0][data] != null ? props.TERMINALREDUCER.terminalData[0][data] : '-'} </b></button>
                                                            </td>
                                                        </tr>
                                                    )
                                                case 'maxTranAmount':
                                                case 'fee':
                                                    return (
                                                        <tr key={data}>
                                                            <th >{heading[data]}</th>
                                                            <th>:</th>
                                                            <td> ${props.TERMINALREDUCER.terminalData[0] && Object.keys(props.TERMINALREDUCER.terminalData[0]).includes(data) && props.TERMINALREDUCER.terminalData[0][data] != null ? props.TERMINALREDUCER.terminalData[0][data] : '-'}</td>
                                                        </tr>

                                                    )

                                                case 'merchantName':
                                                    return (
                                                        <tr key={data}>
                                                            <th >{heading[data]}</th>
                                                            <th>:</th>
                                                            <td>
                                                                {/* eslint-fix: preserve loose-equality coercion */}
                                                                {Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ? <button size='small' onClick={handleMerchantClick}><b>{props.TERMINALREDUCER.terminalData[0] && Object.keys(props.TERMINALREDUCER.terminalData[0]).includes(data) && props.TERMINALREDUCER.terminalData[0][data] != null ? props.TERMINALREDUCER.terminalData[0][data] : '-'} </b></button> : props.TERMINALREDUCER.terminalData[0][data]}
                                                            </td>
                                                        </tr>
                                                    )
                                                default:
                                                    return (
                                                        <tr key={data}>
                                                            <th >{heading[data]}</th>
                                                            <th>:</th>
                                                            <td>{props.TERMINALREDUCER.terminalData[0] && Object.keys(props.TERMINALREDUCER.terminalData[0]).includes(data) && props.TERMINALREDUCER.terminalData[0][data] != null ? props.TERMINALREDUCER.terminalData[0][data] : '-'}</td>
                                                        </tr>
                                                    )
                                            }
                                        }) : null}


                                    </tbody>
                                </table>
                            </div>

                        </PanelBody>

                    </Panel>
                </div>
                <div className="col-xl-8">
                    <TerminalBatchList terminalID={props.TERMINALREDUCER.terminalID}></TerminalBatchList>
                </div>

                <div className="col-xl-12">
                    <Panel>
                        <PanelHeader>TRANSACTIONS</PanelHeader>
                        <Table height={600} headings={tableHeadings.terminalTransactions} data={props.TRANSACTIONREDUCER.transactionsData} />
                    </Panel>
                </div>

                {unassignPTIDModelOpen ? UNASSIGN_CONFIRMATION : null}
                {terminalHistoryModelOpen ? HISTORY_FORM : null}
                {addModelOpen ? VIEW_PROCESSINGGROUPING_FORM : null}
                {assignPTIDModelOpen ? VIEW_PROCESSORTID_ASSIGN_FORM : null}

                {/* eslint-fix: preserve loose-equality coercion */}
                {Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ?
                    <div className="col-xl-5">
                        {/* <Panel>
                            <PanelHeader>Terminal History</PanelHeader>
                            < Table headings={tableHeadings.terminalHistory} data={props.TERMINALREDUCER.terminalHistory} />
                        </Panel> */}
                        {/* <TerminalHistory></TerminalHistory> */}
                    </div>

                    : null}

            </div>


        </div>
    )

}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchTerminal,
    fetchTerminalTransactions,
    resetKey,
    fetchTerminalHistory,
    fetchCassetteData,
    fetchMerchants,
    setTerminalID,
    setMerchantID,
    setClone,
    setProcessorTerminalID,
    unassignProcessorTermID
}


export default connect(mapStateToProps, mapDispatchToProps)(TerminalProfile);